import { BillingProcess, PlanTypes } from '@gonfalon/billing/types';
import { enableSelfServeObservability } from '@gonfalon/dogfood-flags/dogfood-flags';

import type { Plan } from '../types';
import { CheckoutProcess } from '../types';

import {
  advancedUserTargeting,
  customAIRuns,
  customRolesTeams,
  foundationPlus,
  hundredDayRetention,
  releaseAssistant,
  releaseAutomation,
  samlScim,
  workflowsSchedulingApprovals,
} from './sharedFeatures';

export const guardianPlan: Plan = {
  id: PlanTypes.GUARDIAN2024,
  planType: PlanTypes.GUARDIAN2024,
  billingProcess: BillingProcess.INVOICED,
  checkoutProcess: CheckoutProcess.CONTACT_US,
  marketingCopy: {
    name: 'Guardian',
    tagLine: 'Enterprise-grade runtime control, built for scale and security',
    pricingHeadline: 'Custom pricing',
    pricingDescription: "Get a tailored plan built to support your team's growth.",
    featuresHeader: 'Everything in Foundation, plus',
    ctaButtonText: 'Get quote',
    features: [
      { text: 'Release-level error detection' },
      { text: 'Active monitoring & rollbacks' },
      { text: 'Custom roles and approvals' },
      { text: 'Automated release pipelines' },
      { text: '24×7×365 Support' },
      { text: 'Sessions, errors: 20K/month, each', gatedByFlag: enableSelfServeObservability },
      { text: 'Traces, logs: 200M/month, each', gatedByFlag: enableSelfServeObservability },
    ],
  },
  versions: {
    // Default matches base plan
    1: {
      products: [],
    },
    // Display-only: full platform (CC+AC) grouped features
    2: {
      planTitle: 'Guardian',
      marketingCopy: {
        tagLine: 'Monitor and guard everything you ship features and agents.',
        pricingDescription: 'Contact us for customized plans',
        featuresHeader: '',
        features: [],
        featureGroups: [
          {
            header: 'CodeControl',
            features: [
              foundationPlus,
              advancedUserTargeting,
              releaseAutomation,
              workflowsSchedulingApprovals,
              samlScim,
              releaseAssistant,
              customRolesTeams,
            ],
          },
          {
            header: 'AgentControl',
            features: [
              advancedUserTargeting,
              releaseAutomation,
              workflowsSchedulingApprovals,
              samlScim,
              releaseAssistant,
              customRolesTeams,
              customAIRuns,
              hundredDayRetention,
            ],
          },
        ],
      },
      products: [],
    },
    // Display-only: AC only features
    3: {
      planTitle: 'Guardian',
      marketingCopy: {
        tagLine: 'Monitor and guard every agent in production.',
        pricingDescription: 'Contact us for customized plans',
        featuresHeader: 'Everything in Foundation, plus',
        features: [
          advancedUserTargeting,
          releaseAutomation,
          workflowsSchedulingApprovals,
          samlScim,
          releaseAssistant,
          customRolesTeams,
          customAIRuns,
          hundredDayRetention,
        ],
      },
      products: [],
    },
  },
};
